import { render, staticRenderFns } from "./InstantCreditFormStepPhysicalAddress.vue?vue&type=template&id=5cc4e70a&scoped=true"
import script from "./InstantCreditFormStepPhysicalAddress.vue?vue&type=script&lang=js"
export * from "./InstantCreditFormStepPhysicalAddress.vue?vue&type=script&lang=js"
import style0 from "./InstantCreditFormStepPhysicalAddress.vue?vue&type=style&index=0&id=5cc4e70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc4e70a",
  null
  
)

export default component.exports